import React, { useState, useRef } from 'react'
import { supabase } from '../supabase'
import { isTestAccount, autoApproveTestLab } from '../utils/testMode'
import { aiCall } from '../utils/aiClient'

const PAGE_CSS = `
  .sn-input { background: #FFFFFF; border: none; box-shadow: var(--shadow-1), inset 0 1px 3px rgba(56,62,48,0.05); transition: box-shadow var(--t-fast) var(--ease); }
  .sn-input:focus { outline: none; box-shadow: 0 0 0 3px rgba(61,92,60,0.30), var(--shadow-1); }
`

const s = {
  wrap: { minHeight: '100vh', background: 'transparent', display: 'flex', flexDirection: 'column' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(8px)', boxShadow: 'var(--shadow-1)' },
  logo: { fontFamily: 'Fraunces, serif', fontSize: '19px', fontWeight: 500, color: '#20241F' },
  logoEm: { color: '#3D5C3C' },
  back: { fontSize: '13px', color: '#73736A', cursor: 'pointer', background: 'none', border: 'none' },
  content: { flex: 1, padding: '28px 24px', maxWidth: '560px', margin: '0 auto', width: '100%' },
  title: { fontFamily: 'Fraunces, serif', fontSize: '30px', fontWeight: 300, letterSpacing: '-0.3px', marginBottom: '6px' },
  titleEm: { fontStyle: 'normal', color: 'inherit' },
  sub: { fontSize: '13px', color: '#73736A', marginBottom: '28px', lineHeight: 1.6 },
  methodRow: { display: 'flex', gap: '10px', marginBottom: '24px' },
  methodBtn: { flex: 1, padding: '14px 10px', borderRadius: '16px', border: 'none', boxShadow: 'var(--shadow-1)', background: '#FFFFFF', cursor: 'pointer', textAlign: 'center', transition: 'all 0.12s' },
  methodBtnActive: { flex: 1, padding: '14px 10px', borderRadius: '16px', border: 'none', boxShadow: '0 0 0 1.5px #3D5C3C, var(--shadow-1)', background: '#EDF3ED', cursor: 'pointer', textAlign: 'center' },
  methodIcon: { fontSize: '24px', marginBottom: '5px' },
  methodLabel: { fontSize: '12px', fontWeight: 600, color: '#20241F' },
  uploadZone: { border: '2px dashed rgba(139,174,138,0.75)', borderRadius: '24px', padding: '40px 20px', textAlign: 'center', background: 'rgba(139,174,138,0.08)', cursor: 'pointer', marginBottom: '16px', transition: 'all 0.15s' },
  uploadIcon: { width: '48px', height: '48px', background: '#3D5C3C', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', boxShadow: 'var(--shadow-pill)' },
  uploadTitle: { fontSize: '15px', fontWeight: 600, marginBottom: '4px' },
  uploadSub: { fontSize: '13px', color: '#73736A' },
  fileInput: { display: 'none' },
  fileCard: { background: '#FFFFFF', border: 'none', boxShadow: 'var(--shadow-1)', borderRadius: '16px', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' },
  fileIcon: { width: '34px', height: '34px', background: '#EDF3ED', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '16px' },
  fileName: { fontSize: '13px', fontWeight: 500 },
  fileSize: { fontSize: '11px', color: '#73736A' },
  fileRemove: { marginLeft: 'auto', fontSize: '12px', color: '#73736A', fontWeight: 600, cursor: 'pointer' },
  manualSection: { marginBottom: '16px' },
  manualSearch: { width: '100%', borderRadius: '14px', padding: '13px 15px', fontSize: '16px', marginBottom: '10px', color: '#20241F', boxSizing: 'border-box' },
  foodItem: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '11px 0' },
  foodName: { fontSize: '14px', fontWeight: 400 },
  levelBtns: { display: 'flex', gap: '5px' },
  levelBtn: { padding: '4px 10px', borderRadius: '999px', border: 'none', boxShadow: 'var(--shadow-1)', background: '#FFFFFF', fontSize: '11px', cursor: 'pointer', fontWeight: 600, color: '#73736A', transition: 'all 0.1s' },
  levelBtnOn: { padding: '4px 10px', borderRadius: '999px', border: 'none', boxShadow: 'var(--shadow-pill)', background: '#3D5C3C', fontSize: '11px', cursor: 'pointer', fontWeight: 600, color: '#FFFFFF' },
  processingCard: { background: '#FFFFFF', border: 'none', boxShadow: 'var(--shadow-2)', borderRadius: '24px', padding: '32px 24px', textAlign: 'center', marginBottom: '16px' },
  spinner: { width: '36px', height: '36px', border: '3px solid #EDF3ED', borderTopColor: '#3D5C3C', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' },
  processingTitle: { fontFamily: 'Fraunces, serif', fontSize: '18px', fontWeight: 400, marginBottom: '6px' },
  processingTitle2: { color: '#3D5C3C' },
  processingSub: { fontSize: '13px', color: '#73736A' },
  resultSection: { marginBottom: '20px' },
  resultHeader: { display: 'block', marginBottom: '8px' },
  resultItem: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', background: '#FFFFFF', border: 'none', boxShadow: 'var(--shadow-1)', borderRadius: '16px', marginBottom: '7px' },
  resultLeft: { display: 'flex', alignItems: 'center', gap: '9px', fontSize: '14px' },
  resultDot: { width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0 },
  badge: { fontSize: '11px', fontWeight: 500, padding: '3px 9px', borderRadius: '999px' },
  editSelect: { fontSize: '16px', border: 'none', boxShadow: 'var(--shadow-1)', borderRadius: '10px', padding: '3px 7px', background: '#FFFFFF', color: '#20241F', cursor: 'pointer' },
  confirmBar: { background: 'rgba(139,174,138,0.12)', borderRadius: '16px', padding: '11px 14px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#3D5C3C' },
  checkIcon: { width: '16px', height: '16px', background: '#3D5C3C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  errorCard: { background: '#FAEAEA', borderRadius: '16px', padding: '14px', marginBottom: '16px', fontSize: '13px', color: '#C95B5B', lineHeight: 1.6 },
  cta: { width: '100%', marginBottom: '10px' },
  secBtn: { width: '100%' },
}

const COMMON_FOODS = [
  'Beef', 'Chicken', 'Pork', 'Lamb', 'Turkey', 'Egg White', 'Egg Yolk',
  'Cow Milk', 'Cheese', 'Yogurt', 'Butter', 'Whey',
  'Wheat', 'Gluten', 'Corn', 'Rice', 'Oats', 'Barley', 'Rye',
  'Almond', 'Cashew', 'Walnut', 'Peanut', 'Pistachio', 'Hazelnut', 'Pecan',
  'Soy', 'Tofu',
  'Salmon', 'Tuna', 'Shrimp', 'Cod', 'Halibut', 'Scallop', 'Crab', 'Lobster',
  'Broccoli', 'Spinach', 'Tomato', 'Carrot', 'Celery', 'Garlic', 'Onion', 'Mushroom', 'Potato', 'Sweet Potato',
  'Apple', 'Banana', 'Orange', 'Strawberry', 'Blueberry', 'Grape', 'Pineapple', 'Mango', 'Avocado', 'Lemon',
  'Coffee', 'Tea', 'Cocoa', 'Vanilla', 'Cane Sugar', 'Honey', 'Sesame', 'Sunflower Seed', 'Flaxseed',
]

// Canonicalize extracted food names to the app's vocabulary (QA 2026-10-22 #4):
// getTestingOrder looks up intake frequency by exact name, so "Cow's Milk" from
// a lab PDF silently loses its "Cow Milk — Daily" rating and drops to the back
// of the frequency-first testing order. Normalize before anything is saved.
const CANON_BY_KEY = COMMON_FOODS.reduce((m, f) => { m[f.toLowerCase()] = f; return m }, {})
const FOOD_ALIASES = {
  'milk': 'Cow Milk', 'cow milk': 'Cow Milk', 'cows milk': 'Cow Milk', 'whole milk': 'Cow Milk', 'dairy milk': 'Cow Milk',
  'egg whites': 'Egg White', 'egg yolks': 'Egg Yolk', 'eggs': 'Egg White', 'egg': 'Egg White',
  'wheat gluten': 'Gluten', 'soybean': 'Soy', 'soya': 'Soy', 'peanuts': 'Peanut', 'almonds': 'Almond',
  'cashews': 'Cashew', 'walnuts': 'Walnut', 'tomatoes': 'Tomato', 'potatoes': 'Potato', 'carrots': 'Carrot',
  'onions': 'Onion', 'mushrooms': 'Mushroom', 'apples': 'Apple', 'bananas': 'Banana', 'oranges': 'Orange',
  'strawberries': 'Strawberry', 'blueberries': 'Blueberry', 'grapes': 'Grape', 'lemons': 'Lemon',
  'shrimps': 'Shrimp', 'scallops': 'Scallop', 'sugar': 'Cane Sugar', 'sesame seed': 'Sesame', 'sesame seeds': 'Sesame',
  'sunflower seeds': 'Sunflower Seed', 'flax': 'Flaxseed', 'flax seed': 'Flaxseed', 'flax seeds': 'Flaxseed',
}
const canonFoodName = (raw) => {
  const cleaned = String(raw || '').trim().replace(/\s+/g, ' ')
  if (!cleaned) return cleaned
  // strip possessives and parentheticals: "Cow's Milk" -> "cow milk", "Wheat (gluten)" -> "wheat"
  const key = cleaned.toLowerCase().replace(/[’']s\b/g, '').replace(/[’']/g, '').replace(/\s*\(.*\)\s*/g, ' ').replace(/\s+/g, ' ').trim()
  const tryKeys = [key, key.endsWith('s') ? key.slice(0, -1) : key + 's']
  for (const k of tryKeys) {
    if (CANON_BY_KEY[k]) return CANON_BY_KEY[k]
    if (FOOD_ALIASES[k]) return FOOD_ALIASES[k]
  }
  return cleaned // off-list food: keep it as the report names it
}

const SENSITIVITY_COLORS = {
  High: { bg: '#FBE9E9', color: '#A32D2D', dot: '#D64545' },
  Moderate: { bg: '#FCEFD9', color: '#8A5410', dot: '#E8941F' },
  Low: { bg: '#DEF2EE', color: '#1A6256', dot: '#2C9D8A' },
}

export default function LabResults({ session, onComplete, onBack }) {
  const [method, setMethod] = useState('pdf')
  const [file, setFile] = useState(null)
  const [uploadedFile, setUploadedFile] = useState(null)
  const [processing, setProcessing] = useState(false)
  const [processingMsg, setProcessingMsg] = useState('')
  const [extractedFoods, setExtractedFoods] = useState(null)
  const [error, setError] = useState('')
  const [search, setSearch] = useState('')
  const [manualFoods, setManualFoods] = useState({})
  // Off-list foods the user added by hand (QA 2026-10-22 #2): real lab panels
  // run 96–200+ foods, so the fixed picker list needs an escape hatch.
  const [customFoods, setCustomFoods] = useState([])
  const [saving, setSaving] = useState(false)
  const [noSensitivities, setNoSensitivities] = useState(false)
  const fileRef = useRef()
  const cameraRef = useRef()

  const handleFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0])
      setUploadedFile(e.target.files[0])
      setExtractedFoods(null)
      setError('')
    }
  }

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result.split(',')[1])
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

  // Downscale/re-encode a photo to a JPEG the pipeline can carry (QA 2026-10-22
  // #6): the proxy function caps request bodies around 6MB and base64 adds a
  // third, so an un-shrunk phone photo fails at the transport layer; HEIC and
  // other formats the vision API can't take get converted by the canvas here.
  const shrinkImage = (f) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(f)
    const img = new Image()
    img.onload = () => {
      try {
        const maxSide = 1600
        const scale = Math.min(1, maxSide / Math.max(img.width, img.height))
        const canvas = document.createElement('canvas')
        canvas.width = Math.max(1, Math.round(img.width * scale))
        canvas.height = Math.max(1, Math.round(img.height * scale))
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height)
        URL.revokeObjectURL(url)
        resolve(canvas.toDataURL('image/jpeg', 0.85).split(',')[1])
      } catch (e) { URL.revokeObjectURL(url); reject(e) }
    }
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('unreadable image')) }
    img.src = url
  })

  const analyzeFile = async () => {
    if (!file) return
    setProcessing(true)
    setError('')

    const isPDF = file.type === 'application/pdf'
    if (isPDF && file.size > 4.5 * 1024 * 1024) {
      setError('That PDF is too large to read automatically (over 4.5MB). Try exporting a smaller copy, or enter your results manually — it only takes a minute.')
      setProcessing(false)
      return
    }

    let base64, mediaType
    try {
      setProcessingMsg('Reading your results...')
      if (isPDF) {
        base64 = await toBase64(file)
        mediaType = file.type
      } else {
        base64 = await shrinkImage(file)
        mediaType = 'image/jpeg'
      }
    } catch (err) {
      setError("We couldn't read that photo format. Take the photo again with your camera app set to a standard format, upload a PDF, or enter your results manually.")
      setProcessing(false)
      return
    }

    try {

      setTimeout(() => setProcessingMsg('Identifying flagged foods...'), 1200)
      setTimeout(() => setProcessingMsg('Categorizing sensitivity levels...'), 2400)

      const messages = [{
            role: 'user',
            content: [
              {
                type: isPDF ? 'document' : 'image',
                source: {
                  type: 'base64',
                  media_type: mediaType,
                  data: base64,
                },
              },
              {
                type: 'text',
                text: `This is a food sensitivity lab result. Extract all flagged foods and their sensitivity levels. 
                
Return ONLY a JSON object with this exact structure, no other text:
{"foods":[["Food Name","High"],["Food Name","Moderate"],["Food Name","Low"]]}

Rules:
- Only include foods that showed a reaction (High, Moderate, or Low)
- Do not include foods with no reaction or foods not tested
- The second element must be exactly "High", "Moderate", or "Low"
- Food names should be clean and capitalized (e.g. "Cow Milk" not "cow's milk IgG")
- Return only the JSON, compact, one line if possible, no markdown, no explanation`
              }
            ]
          }]

      // 1500 tokens + the compact pair format (QA 2026-11-02 #2): real panels
      // flag 60-100+ foods, and the old verbose JSON truncated at 1000 tokens,
      // throwing at JSON.parse with a generic error.
      const text = await aiCall(messages, 1500)
      const clean = text.replace(/```json|```/g, '').trim()
      const parsed = JSON.parse(clean)

      const VALID_LEVELS = ['High', 'Moderate', 'Low']
      const foods = (parsed.foods || []).map(f => {
        // Accept both the compact pair shape and the legacy object shape.
        const name = Array.isArray(f) ? f[0] : f.name
        let level = Array.isArray(f) ? f[1] : f.level
        // Coerce out-of-vocabulary levels (QA 2026-11-02 #6: they used to count
        // in the banner, render in no section, and submit invisibly).
        level = VALID_LEVELS.find(v => v.toLowerCase() === String(level || '').toLowerCase()) || 'Moderate'
        return { name: canonFoodName(name), level }
      }).filter(f => f.name)
      setExtractedFoods(foods)
      setProcessingMsg('')
    } catch (err) {
      setError("That report couldn't be read in one pass — long multi-page panels sometimes overflow the reader. Try one page at a time, or enter the flagged foods manually (it only takes a minute).")
    }

    setProcessing(false)
  }

  const updateFoodLevel = (index, level) => {
    const updated = [...extractedFoods]
    updated[index].level = level
    setExtractedFoods(updated)
  }

  const toggleManualFood = (food, level) => {
    setManualFoods(prev => {
      if (prev[food] === level) {
        const updated = { ...prev }
        delete updated[food]
        return updated
      }
      return { ...prev, [food]: level }
    })
    // Flagging a food contradicts "my report shows no sensitivities" — clear
    // the toggle instead of silently ignoring it at submit.
    if (manualFoods[food] !== level) setNoSensitivities(false)
  }

  const getManualFoodsAsArray = () => {
    return Object.entries(manualFoods).map(([name, level]) => ({ name, level }))
  }

  const [reviewing, setReviewing] = useState(false)
  const [uploadFailed, setUploadFailed] = useState(false)
  const handleSave = async (skipFile = false) => {
    // Manual entry gets a review gate: first press shows the read-back, second confirms (finding #16)
    if (method === 'manual' && !reviewing) {
      const list = getManualFoodsAsArray()
      if ((list && list.length > 0) || noSensitivities) { setReviewing(true); setError(''); return }
    }
    setSaving(true)
    const foods = method === 'manual' ? getManualFoodsAsArray() : extractedFoods

    if (!foods || foods.length === 0) {
      if (!noSensitivities) {
        setError('Please add at least one flagged food, or select "My report shows no sensitivities" below.')
        setSaving(false)
        return
      }
    }

    let file_path = null
    // Manual entry never carries a file (QA 2026-11-02 #3: a stale abandoned
    // upload used to block manual submits with copy about a file the user
    // never meant to send).
    if (uploadedFile && !skipFile && method !== 'manual') {
      const fileExt = uploadedFile.name?.split('.').pop() || 'jpg'
      const fileName = `${session.user.id}-${Date.now()}.${fileExt}`
      const { data: storageData, error: storageError } = await supabase.storage
        .from('lab-results')
        .upload(fileName, uploadedFile, { contentType: uploadedFile.type, upsert: true })
      if (!storageError && storageData) {
        // Store only the path. The bucket is private; the admin dashboard
        // generates short-lived signed URLs for viewing. Never a public URL.
        file_path = fileName
      } else {
        // Direct upload blocked (the bucket's RLS rejects client INSERTs — QA
        // 2026-11-02 #1): route the file through the service-role function,
        // which verifies the session server-side and writes on our behalf.
        try {
          const { data: { session: auth } } = await supabase.auth.getSession()
          // Big photos get re-encoded down before the trip (function body cap);
          // PDFs ride as-is and oversized ones fall through to the error path.
          let b64, ctype, extx
          if (uploadedFile.type.startsWith('image/') && uploadedFile.size > 2.5 * 1024 * 1024) {
            b64 = await shrinkImage(uploadedFile); ctype = 'image/jpeg'; extx = 'jpg'
          } else {
            b64 = await toBase64(uploadedFile); ctype = uploadedFile.type; extx = fileExt
          }
          if (b64 && b64.length < 5.4 * 1024 * 1024) {
            const res = await fetch('/.netlify/functions/upload-lab-file', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', ...(auth?.access_token ? { Authorization: `Bearer ${auth.access_token}` } : {}) },
              body: JSON.stringify({ data: b64, contentType: ctype, ext: extx }),
            })
            const out = await res.json().catch(() => ({}))
            if (res.ok && out.file_path) file_path = out.file_path
          }
        } catch (e) {}
      }
      if (!file_path) {
        // A failed upload used to be swallowed: the submission went through
        // file-less and nobody — user or reviewer — learned the original
        // document was lost (QA 2026-10-22 #5). Stop and say so instead.
        setUploadFailed(true)
        setError("Your reviewed foods are ready, but uploading the original file didn't go through, so we stopped before submitting. Tap submit to try again, or submit without the original file below.")
        setSaving(false)
        return
      }
    }

    const { error } = await supabase.from('lab_results').upsert({
      user_id: session.user.id,
      user_name: session.user.user_metadata?.full_name || session.user.email,
      foods,
      file_path,
      submitted_at: new Date().toISOString(),
      status: 'pending_review',
    })

    if (error) {
      setError('Could not save your results. Please try again.')
      setSaving(false)
      return
    }

    // Checked (QA sentinel S3): the lab row is saved above; if this phase
    // advance fails silently the account is stranded (lab submitted, dashboard
    // still says "upload your lab"). Retry once, then surface it.
    let phaseOk = false
    for (let i = 0; i < 2 && !phaseOk; i++) {
      const { error: pErr, data: pRows } = await supabase.from('profiles')
        .update({ program_phase: 'pending_review' }).eq('id', session.user.id).select()
      phaseOk = !pErr && pRows && pRows.length > 0
    }
    if (!phaseOk) {
      setError('Your results were saved, but your dashboard did not advance. Please refresh; if it still shows the upload step, tap submit again.')
      setSaving(false)
      return
    }

    // TESTING ONLY: robot accounts (+fable/+qa/+robot emails) skip the human
    // admin gate so automated end-to-end walks can run. Real customers always
    // wait for admin review, exactly as above.
    if (isTestAccount(session.user.email)) {
      try { await autoApproveTestLab(supabase, session.user.id, foods) } catch (e) {}
    }

    setSaving(false)
    onComplete()
  }

  // Search-first (#14): with an empty search, show only foods already flagged
  // (kept visible so entries remain reviewable/editable). Typing reveals matches.
  const allPickableFoods = [...COMMON_FOODS, ...customFoods.filter(c => !COMMON_FOODS.includes(c))]
  const filteredFoods = search.trim()
    ? allPickableFoods.filter(f => f.toLowerCase().includes(search.toLowerCase()))
    : allPickableFoods.filter(f => manualFoods[f])
  // The canonicalizer guards this door too (QA 2026-11-02 #4: "Cows Milk"
  // used to add a duplicate beside canonical "Cow Milk", breaking the
  // frequency-ordering and verdict-keying the aliases exist to protect).
  const canonOfSearch = canonFoodName(search.trim())
  const searchResolvesToKnown = !!search.trim() && COMMON_FOODS.includes(canonOfSearch) && filteredFoods.length === 0
  const addCustomFood = () => {
    if (searchResolvesToKnown) { setSearch(canonOfSearch); return }
    const nm = search.trim().replace(/\s+/g, ' ').replace(/\w\S*/g, t => t[0].toUpperCase() + t.slice(1).toLowerCase())
    if (!nm) return
    setCustomFoods(prev => prev.includes(nm) ? prev : [...prev, nm])
    // Keep the search as-is: the new food matches it, so its pill row appears right here.
  }

  // Rendered in manual entry and in the upload path when extraction finds zero foods.
  // Mutually exclusive with flagged foods: flagging clears it, and while foods
  // are flagged it reads as unavailable instead of silently losing at submit.
  const hasManualFlags = Object.keys(manualFoods).length > 0 && method === 'manual'
  const noSensitivitiesToggle = (
    <button
      onClick={() => { if (hasManualFlags) return; setNoSensitivities(v => !v); setError('') }}
      style={{ width: '100%', textAlign: 'left', background: noSensitivities ? '#EDF3ED' : '#F7F5EE', border: 'none', boxShadow: noSensitivities ? '0 0 0 1.5px #3D5C3C, var(--shadow-1)' : 'none', borderRadius: '16px', padding: '13px 15px', fontSize: '13.5px', color: '#20241F', cursor: hasManualFlags ? 'default' : 'pointer', marginBottom: '10px', fontWeight: noSensitivities ? 600 : 400, opacity: hasManualFlags ? 0.45 : 1 }}>
      My report shows no sensitivities
      <div style={{ fontSize: '12px', color: '#73736A', fontWeight: 400, marginTop: '3px', lineHeight: 1.5 }}>
        {hasManualFlags
          ? "You've flagged foods above — clear them first if your report truly shows none."
          : "That's a real result. We'll review it and recommend the right path, often testing common trigger foods instead."}
      </div>
    </button>
  )

  return (
    <div style={s.wrap}>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }` + PAGE_CSS}</style>
      <div style={s.topBar}>
        <button style={s.back} onClick={onBack}>← Back</button>
        <div style={s.logo}>Sensify<span style={{ color: '#3D5C3C' }}>.</span></div>
        <div style={{ width: 40 }}></div>
      </div>

      <div className="sn-rise" style={s.content}>
        <div className="sn-micro" style={{ marginBottom: '8px' }}>Your lab results</div>
        <div style={s.title}>Add your test results.</div>
        <div style={s.sub}>Enter only the foods that showed a reaction. Anything you leave out is treated as clear.</div>

        <div style={s.methodRow}>
          {/* Method switches clear any abandoned file (QA 2026-11-02 #3). */}
          <div style={method === 'pdf' ? s.methodBtnActive : s.methodBtn} onClick={() => { setMethod('pdf'); setExtractedFoods(null); setFile(null); setUploadedFile(null); setUploadFailed(false); setError('') }}>
            <div style={s.methodIcon}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <div style={s.methodLabel}>Upload PDF</div>
          </div>
          <div style={method === 'photo' ? s.methodBtnActive : s.methodBtn} onClick={() => { setMethod('photo'); setExtractedFoods(null); setFile(null); setUploadedFile(null); setUploadFailed(false); setError('') }}>
            <div style={s.methodIcon}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>
            </div>
            <div style={s.methodLabel}>Take photo</div>
          </div>
          <div style={method === 'manual' ? s.methodBtnActive : s.methodBtn} onClick={() => { setMethod('manual'); setExtractedFoods(null); setFile(null); setUploadedFile(null); setUploadFailed(false); setError('') }}>
            <div style={s.methodIcon}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </div>
            <div style={s.methodLabel}>Manual entry</div>
          </div>
        </div>

        {error && <div style={s.errorCard}>{error}</div>}
        {uploadFailed && !saving && (
          <button className="sn-btn sn-btn-quiet" style={{ width: '100%', marginBottom: '16px' }} onClick={() => { setUploadFailed(false); setError(''); handleSave(true) }}>
            Submit without the original file
          </button>
        )}

        {(method === 'pdf' || method === 'photo') && !extractedFoods && !processing && (
          <div style={{ background: '#22301F', borderRadius: 16, boxShadow: 'var(--shadow-3)', padding: '13px 15px', display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 16 }}>
            <span style={{ color: '#8BAE8A', fontSize: 14, flexShrink: 0, marginTop: 1 }}>{'\u2726'}</span>
            <div style={{ fontSize: 12, color: 'rgba(250,248,244,0.75)', lineHeight: 1.55 }}>We read the reacted foods automatically. You review and confirm before anything is saved.</div>
          </div>
        )}

        {(method === 'pdf' || method === 'photo') && !extractedFoods && !processing && (
          <>
            <div style={s.uploadZone} onClick={() => method === 'photo' ? cameraRef.current.click() : fileRef.current.click()}>
              <div style={s.uploadIcon}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                  <polyline points="17 8 12 3 7 8"/>
                  <line x1="12" y1="3" x2="12" y2="15"/>
                </svg>
              </div>
              <div style={s.uploadTitle}>{method === 'photo' ? 'Take a photo' : 'Upload your PDF'}</div>
              <div style={s.uploadSub}>{method === 'photo' ? 'Point your camera at your results' : 'Tap to browse your files'}</div>
            </div>
            <input ref={fileRef} type="file" accept=".pdf" style={s.fileInput} onChange={handleFile} />
            <input ref={cameraRef} type="file" accept="image/*" capture="environment" style={s.fileInput} onChange={handleFile} />

            {file && (
              <div style={s.fileCard}>
                <div style={s.fileIcon}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3D5C3C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {method === 'photo'
                      ? <><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></>
                      : <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></>
                    }
                  </svg>
                </div>
                <div>
                  <div style={s.fileName}>{file.name}</div>
                  <div style={s.fileSize}>{(file.size / 1024).toFixed(0)} KB · Ready to analyze</div>
                </div>
                <div style={s.fileRemove} onClick={() => { setFile(null); setUploadedFile(null); setUploadFailed(false) }}>Remove</div>
              </div>
            )}

            <button className="sn-btn" style={s.cta} onClick={analyzeFile} disabled={!file}>
              Read my results
            </button>
            <button className="sn-btn sn-btn-quiet" style={s.secBtn} onClick={() => setMethod('manual')}>Enter manually instead</button>
          </>
        )}

        {processing && (
          <div style={s.processingCard}>
            <div style={s.spinner}></div>
            <div style={s.processingTitle}>
              <em style={s.processingTitle2}>{processingMsg}</em>
            </div>
            <div style={s.processingSub}>This takes about 10 seconds</div>
          </div>
        )}

        {extractedFoods && !processing && (
          <>
            <div style={s.confirmBar}>
              <div style={s.checkIcon}>
                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              {extractedFoods.length} food{extractedFoods.length !== 1 ? 's' : ''} extracted from your results
            </div>

            {['High', 'Moderate', 'Low'].map(level => {
              const foods = extractedFoods.filter(f => f.level === level)
              if (foods.length === 0) return null
              const colors = SENSITIVITY_COLORS[level]
              return (
                <div key={level} style={s.resultSection}>
                  <div className="sn-micro sn-micro-dim" style={s.resultHeader}>{level} sensitivity</div>
                  {foods.map((food, i) => (
                    <div key={i} style={s.resultItem}>
                      <div style={s.resultLeft}>
                        <div style={{ ...s.resultDot, background: colors.dot }}></div>
                        {food.name}
                      </div>
                      {/* One control, not a badge + a matching dropdown: the
                          select IS the level display, tinted like the old badge. */}
                      <select
                        style={{ ...s.editSelect, background: colors.bg, color: colors.color, fontWeight: 600 }}
                        value={food.level}
                        onChange={e => updateFoodLevel(extractedFoods.indexOf(food), e.target.value)}
                      >
                        <option>High</option>
                        <option>Moderate</option>
                        <option>Low</option>
                      </select>
                    </div>
                  ))}
                </div>
              )
            })}

            {extractedFoods.length === 0 && noSensitivitiesToggle}

            <button className="sn-btn" style={s.cta} onClick={() => handleSave()} disabled={saving}>
              {saving ? 'Submitting...' : 'Looks right, submit for review →'}
            </button>
            <button className="sn-btn sn-btn-quiet" style={s.secBtn} onClick={() => setExtractedFoods(null)}>Re-analyze</button>
          </>
        )}

        {method === 'manual' && (
          <div style={{ fontSize: '13px', color: '#7A7A72', lineHeight: 1.6, marginBottom: '12px' }}>Add each food your lab report flags, one at a time. Most reports list 3 to 12 foods. Search below and pick the sensitivity level shown on your report.</div>
        )}
        {method === 'manual' && (
          <>
            <input
              className="sn-input"
              style={s.manualSearch}
              placeholder="Search foods"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <div style={{ fontSize: '12.5px', color: '#7A7A72', marginBottom: '12px', lineHeight: 1.55 }}>
              Search for each food on your results, then tap its level. Only what you flag gets saved.
            </div>
            {Object.keys(manualFoods).length > 0 && (
              <div style={{ background: '#22301F', borderRadius: 16, boxShadow: 'var(--shadow-3)', padding: '11px 14px', display: 'flex', alignItems: 'center', gap: 9, marginBottom: 14 }}>
                <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#8BAE8A', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#22301F" strokeWidth="4"><polyline points="20 6 9 17 4 12"/></svg></div>
                <span style={{ fontSize: 12.5, color: 'rgba(250,248,244,0.85)' }}>{Object.keys(manualFoods).length} food{Object.keys(manualFoods).length !== 1 ? 's' : ''} flagged so far</span>
              </div>
            )}
            <div style={s.manualSection}>
              {filteredFoods.map((food) => {
                const lvl = manualFoods[food]
                const pill = (label, val) => (
                  <button
                    onClick={() => toggleManualFood(food, val)}
                    style={{ flex: 1, textAlign: 'center', padding: '11px 0', borderRadius: 999, border: 'none', cursor: 'pointer', fontSize: 12.5,
                      fontWeight: 600,
                      background: lvl === val ? '#3D5C3C' : '#F7F5EE',
                      color: lvl === val ? '#fff' : '#8A8A82',
                      boxShadow: lvl === val ? 'var(--shadow-pill)' : 'none', transition: 'all 0.12s' }}>{label}</button>
                )
                return (
                  <div key={food} style={{ background: '#FFFFFF', border: 'none', boxShadow: 'var(--shadow-1)', borderRadius: 16, padding: '14px 15px', marginBottom: 9 }}>
                    <div style={{ fontSize: 14.5, fontWeight: 500, color: '#20241F', marginBottom: 11 }}>{food}</div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {pill('High', 'High')}
                      {pill('Moderate', 'Moderate')}
                      {pill('Low', 'Low')}
                    </div>
                  </div>
                )
              })}
              {search.trim() && filteredFoods.length === 0 && (
                <div style={{ background: '#FFFFFF', boxShadow: 'var(--shadow-1)', borderRadius: 16, padding: '15px', marginBottom: 9 }}>
                  {searchResolvesToKnown ? (
                    <>
                      <div style={{ fontSize: 14, fontWeight: 500, color: '#20241F', marginBottom: 4 }}>Did you mean “{canonOfSearch}”?</div>
                      <div style={{ fontSize: 12.5, color: '#7A7A72', lineHeight: 1.55, marginBottom: 11 }}>That looks like a food already on our list — using the listed name keeps your results tied together.</div>
                      <button className="sn-btn sn-btn-quiet" style={{ width: '100%' }} onClick={() => setSearch(canonOfSearch)}>Yes — show “{canonOfSearch}”</button>
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: 14, fontWeight: 500, color: '#20241F', marginBottom: 4 }}>No match for “{search.trim()}”</div>
                      <div style={{ fontSize: 12.5, color: '#7A7A72', lineHeight: 1.55, marginBottom: 11 }}>Lab reports sometimes flag foods beyond our common list. Add it exactly as your report names it, then tap its level like any other food.</div>
                      <button className="sn-btn sn-btn-quiet" style={{ width: '100%' }} onClick={addCustomFood}>Add “{search.trim()}” as a food</button>
                    </>
                  )}
                </div>
              )}
            </div>

            {noSensitivitiesToggle}

            {reviewing && (
              <div className="sn-hero" style={{ borderRadius: 24, padding: '16px 18px', marginBottom: 10 }}>
                <div className="sn-micro sn-micro-dark" style={{ position: 'relative', marginBottom: 8 }}>Review before submitting</div>
                <div style={{ position: 'relative', fontSize: 13, color: '#FAF8F4', lineHeight: 1.7 }}>
                  {noSensitivities && getManualFoodsAsArray().length === 0
                    ? 'Your report shows no sensitivities. We will review this and recommend your path.'
                    : getManualFoodsAsArray().map(f => `${f.name} (${f.level})`).join(' · ')}
                </div>
                <button onClick={() => setReviewing(false)} style={{ position: 'relative', background: 'transparent', border: 'none', padding: 0, marginTop: 8, fontSize: 12, color: '#8BAE8A', textDecoration: 'underline', cursor: 'pointer' }}>Go back and edit</button>
              </div>
            )}

            <button
              className="sn-btn"
              style={s.cta}
              onClick={() => handleSave()}
              disabled={saving || (Object.keys(manualFoods).length === 0 && !noSensitivities)}
            >
              {saving ? 'Submitting...' : !reviewing ? 'Review my entry →' : 'Looks right, submit for review →'}
            </button>
          </>
        )}
      </div>
    </div>
  )
}
